<form [formGroup]="form" *ngIf="!form.controls.input.disabled">
  <mat-form-field appearance="outline">
    <input
      matInput
      type="text"
      formControlName="input"
      [name]="getOutputName()"
      autocomplete="off"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option
        *ngFor="let option of filteredDictionaryTerms$ | async"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="form.controls.input.hasError('invalidDictionaryValue')">
      {{ validationMessage.invalidDictionaryValue }}
    </mat-error>
  </mat-form-field>
  <div
    *ngIf="trainingAnswer$ | async as trainingAnswer"
    class="training-answer body-01"
  >
    <h3-training-answer-icon></h3-training-answer-icon>
    {{ trainingAnswer }}
  </div>
</form>
<p class="read-only-text" *ngIf="form.controls.input.disabled">
  {{ readOnlyText$ | async }}
</p>
